import { createDate, format, set } from '@lingoda/dates';
import { trans } from '@lingoda/i18n';
import {
    AfternoonIcon,
    EveningIcon,
    MorningIcon,
    NightIcon,
} from '@lingoda/ui/illustrations/timeSlots';
import type { ReactElement } from 'react';

export const getTimeSlotMetaMap = ({ iconSize }: { iconSize?: number } = {}): Record<
    string,
    { title: string; icon: ReactElement }
> => {
    const sizeProps = iconSize ? { width: iconSize, height: iconSize } : {};

    return {
        morning: {
            title: trans('morning', {}, 'student-post-checkout'),
            icon: <MorningIcon {...sizeProps} />,
        },
        afternoon: {
            title: trans('afternoon', {}, 'student-post-checkout'),
            icon: <AfternoonIcon {...sizeProps} />,
        },
        evening: {
            title: trans('evening', {}, 'student-post-checkout'),
            icon: <EveningIcon {...sizeProps} />,
        },
        night: {
            title: trans('night', {}, 'student-post-checkout'),
            icon: <NightIcon {...sizeProps} />,
        },
    };
};

export const getTimeSlotMeta = (
    slug: string,
    startHour: number,
    endHour: number,
    timeFormat: string,
): { title: string; icon?: ReactElement; description: string } | undefined => {
    const metaMap = getTimeSlotMetaMap();
    const timeSlotMeta = metaMap[slug];
    if (!timeSlotMeta) {
        return undefined;
    }

    const start = set({ hours: startHour, minutes: 0 }, createDate());
    const end = set({ hours: endHour, minutes: 0 }, createDate());
    const description = `${format(timeFormat)(start)} - ${format(timeFormat)(end)}`;

    return {
        ...timeSlotMeta,
        description,
    };
};
